import React from 'react';
import { Grid, Typography, CircularProgress } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import '../Dashboard/styleSearch.scss';

function isInvalid(v) {
  return v === undefined || v === null || v === -999 || v === '-999' || Number.isNaN(Number(v));
}

function splitDigits(num) {
  return Number(num).toLocaleString();
}
function roundToTwo(value) {
  return (Math.round((value + Number.EPSILON) * 10000) / 10000).toFixed(2);
}

const dollar = (params) => {
  if (isInvalid(params.value)) return '–';
  return `$ ${splitDigits(roundToTwo(params.value))}`;
};

const pct = (params) => {
  if (isInvalid(params.value)) return '–';
  return `${(params.value * 100).toFixed(2)}%`;
};

const num = (params) => {
  if (params.value === undefined || params.value === null || Number.isNaN(Number(params.value))) return '0';
  return splitDigits(params.value);
};

const makeColumns = (dimensionField, dimensionHeader) => {
  const creativeColumns =
    dimensionField === 'creative_name'
      ? [{ field: 'creative_type', headerName: 'Creative Type', flex: 1, minWidth: 120, align: 'center', headerAlign: 'center' }]
      : [];

  return [
    {
      field: dimensionField,
      headerName: dimensionHeader,
      flex: 2,
      minWidth: 200,
      renderCell: (params) => <div className="campaign_name_settings">{params.value}</div>
    },
    ...creativeColumns,
    { field: 'media_cost', headerName: 'media_cost', flex: 1, minWidth: 120, valueFormatter: dollar, align: 'center', headerAlign: 'center' },
    { field: 'impressions', headerName: 'Impressions', flex: 1, minWidth: 120, valueFormatter: num, align: 'center', headerAlign: 'center' },
    { field: 'clicks', headerName: 'Clicks', flex: 1, minWidth: 100, valueFormatter: num, align: 'center', headerAlign: 'center' },
    { field: 'installs', headerName: 'Installs', flex: 1, minWidth: 100, valueFormatter: num, align: 'center', headerAlign: 'center' },
    { field: 'ecpc', headerName: 'ECPC', flex: 0.8, minWidth: 100, valueFormatter: dollar, align: 'center', headerAlign: 'center' },
    { field: 'cpm', headerName: 'CPM', flex: 0.8, minWidth: 100, valueFormatter: dollar, align: 'center', headerAlign: 'center' },
    { field: 'cpi', headerName: 'CPI', flex: 0.8, minWidth: 100, valueFormatter: dollar, align: 'center', headerAlign: 'center' },
    { field: 'ctr', headerName: 'CTR', flex: 0.8, minWidth: 100, valueFormatter: pct, align: 'center', headerAlign: 'center' },
    { field: 'vcr', headerName: 'Video Completion Rate', flex: 1, minWidth: 160, valueFormatter: pct, align: 'center', headerAlign: 'center' }
  ];
};

const CTVSection = ({ title, dimensionField, dimensionHeader, loading, rows, error }) => {
  const columns = makeColumns(dimensionField, dimensionHeader);

  return (
    <MainCard>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography variant="h3">{title}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className="reportMainContainer">
            {loading ? (
              <CircularProgress style={{ position: 'relative' }} />
            ) : rows.length === 0 ? (
              <Typography style={{ textAlign: 'center' }}>
                {error ? (
                  'No Data Found'
                ) : (
                  <span>
                    Please click <b>Apply Filter</b> to view data
                  </span>
                )}
              </Typography>
            ) : (
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                  sorting: { sortModel: [{ field: 'media_cost', sort: 'desc' }] }
                }}
                loading={loading}
                pageSizeOptions={[10, 20, 30]}
                slots={{ toolbar: GridToolbar }}
                disableRowSelectionOnClick
                disableColumnSelector
                disableDensitySelector
                autoHeight
                getRowHeight={() => 'auto'}
                className="custom-datagrid"
              />
            )}
          </div>
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default CTVSection;
